import { required } from 'vuelidate/lib/validators'

const validaDuration = value => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true
  }
  return /^(?:(?:([01]?\d|2[0-3]):)?([0-5]?\d):)?([0-5]?\d)$/g.test(value)
}

export const validateData = {
    form: {
      type: { required },
      timeMin:{ validaDuration },
    },
    formWhats: {
      token: { required: false },
      url: { required: false },
      code: { required },
    },
}

export const validateComputed = {
    typeErrors() {
      const errors = []
      if (!this.$v.form.type.$dirty) return errors
      !this.$v.form.type.required && errors.push('Campo obrigatório.')
      return errors
    },
    timeMinErrors() {
      const errors = []
      if (!this.$v.form.timeMin.$dirty) return errors
      !this.$v.form.timeMin.validaDuration && errors.push('Formato Invalido')
      return errors
    },
    tokenWhatsErrors() {
      const errors = []
      if (!this.$v.formWhats.token.$dirty) return errors
      !this.$v.formWhats.token.required && errors.push('Campo obrigatório.')
      return errors
    },
    urlWhatsErrors() {
      const errors = []
      if (!this.$v.formWhats.url.$dirty) return errors
      !this.$v.formWhats.url.required && errors.push('Campo obrigatório.')
      return errors
    },
    codeWhatsErrors() {
      const errors = []
      if (!this.$v.formWhats.code.$dirty) return errors
      !this.$v.formWhats.code.required && errors.push('Campo obrigatório.')
      return errors
    },
}
